import { Component, OnInit } from '@angular/core';
import { PortabilityService } from './portability.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { CodificadorJWT } from 'src/util/codificador/CodificadorJWT';
import { DecodificadorJWT } from 'src/util/codificador/DecodificadorJWT';
import { PrivacyService } from '../privacy/privacy.service';
//jquery var
declare var $: any;

@Component({
  selector: 'app-portability',
  templateUrl: './portability.component.html',
  styleUrls: ['./portability.component.scss']
})
export class PortabilityComponent implements OnInit {

  //Declaracion de variables de clase
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isCodeSent = true;
  isModalReload = false;
  documentValue = "";
  numericPattern = "";
  alphanumericPattern = "";
  emailPattern = "";
  addressPattern = "";
  datePattern = "";
  phonePattern = "";
  portabilityForm: FormGroup;
  isFileLoadDocCopy = false;
  isFileLoadDocCopyFront = false;
  isFileLoadDocCopyReverse = false;
  activeTab = 1;
  isNextStepReady = false;
  isBackDisabled = true;
  isStep1Checked = false;
  isStep2Checked = false;
  isLoading = false;
  isDownloading = false;
  cityProvinceList = [];
  inputNamesText = "";
  inputLastNamesText = "";
  inputBornDateText = "";
  labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
  isFinishedProcess = false;

  //data objects
  fileLoadPortFormData = null;
  fileLoadDocCopyData = null;
  fileLoadDocCopyFrontData = null;
  fileLoadDocCopyReverseData = null;
  //Img validations
  pdfOpened = false;
  base64Img = '';
  //file input
  ACCEPT_FILES = constants.ACCEPT_FILES;

  //countdown
  blockSendSMS = false;
  timeLeft: number;
  showTimeLeft = '';
  interval;

  valueAes = '';
  constructor(public LANG: CommonUtilitiesService, private portabilityService: PortabilityService, private _router: Router, private formbuilder: FormBuilder, private privacyService: PrivacyService
  ) { }

  /**
  * Description: Método que inicializa las variables y validaciones del formulario
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  ngOnInit() {
    this.getSemillaAesParam()
    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.phonePattern = constants.REGEX_PHONE_PATTERN;
    this.alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
    this.emailPattern = constants.REGEX_EMAIL_PATTERN;
    this.addressPattern = constants.REGEX_DIRECTION;
    this.portabilityForm = this.formbuilder.group({
      inputCC: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputOperator: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputCurrentPlan: ['', [Validators.required]],
      // inputLineType: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputNumber: ['', [Validators.required, Validators.pattern(this.phonePattern)]],
      inputCodeValidation: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputNames: ['', [Validators.required]],
      inputCity: ['', [Validators.required]],
      inputLastNames: ['', [Validators.required]],
      inputFullAddress: ['', [Validators.required]],
      inputBornDate: ['', [Validators.required]],
      inputAditionalNum: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputEmail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputICC: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputIMEI: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputFileDocCopy: ['', []],
      inputFileDocCopyFront: ['', []],
      inputFileDocCopyReverse: ['', []],
      isShowCanvas: [true, []]
    });

    //se asignan los valores de los tooltips
    this.setTooltips();
    this.getCityProvinceList();
  }

  /**
   * Description: Método que inicializa todos los popovers o tooltips del formulario
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  setTooltips() {
    let iccTooltipText = this.LANG.getLangText('PORTABILITY_TOOLTIP_ICC');
    $('#tooltipICC').popover({
      html: true,
      content: '<div style="text-align: center;" class="test">' + iccTooltipText + '<br><img src="./assets/chip.png"></div>'
    });

    $('#tooltipIMEI').popover({
      html: true,
      content: this.LANG.getLangText('PORTABILITY_TOOLTIP_IMEI')
    });

    $('#tooltipAddNum').popover({
      html: true,
      content: this.LANG.getLangText('PORTABILITY_TOOLTIP_ADDNUM')
    });
  }

  /**
    * Description: Método que obtiene la lista de ciudades y provincias
    * Autor: Diego Diaz
    * @param N/A
    * @return N/A
    */
  getCityProvinceList() {
    this.portabilityService.getCityProvinceList().subscribe((valData => {
      this.cityProvinceList = valData["obj"];
    }),
      (err) => {
        this.cityProvinceList = [];
      });

  }

  /**
   * Description: Método que cambia la pantalla para continuar con el proceso de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  nextStep() {

    if (this.activeTab == 1) {
      // Validacion de campos paso 1
      if (this.portabilityForm.get('inputCC').invalid
        || this.portabilityForm.get('inputICC').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }
      this.isLoading = true;
      this.portabilityService.validateICC(this.portabilityForm.get('inputICC').value).subscribe((valData => {

        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || valData["obj"].valid != true) {
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_VALIDATION_ICC_ERROR');
          this.isShowModal = true;
          this.isLoading = false;
          return false;
        }

        let docType = constants.TYPE_CED;
        let docId = this.portabilityForm.get('inputCC').value;

        this.portabilityService.getInfoByDocument(docType, docId).subscribe((data => {
          this.isLoading = false;
          const jwt = data['args'];
          const parseJWT = new DecodificadorJWT();
				  const dataInfo = parseJWT.decodeToken(jwt, true, this.valueAes);

          if (dataInfo['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
            this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
            this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_VALIDATION_USER_INFO_ERROR');
            this.isShowModal = true;
            return false;
          }

          //carga la data del usuario automaticamente
          var formatedDate = (dataInfo["obj"].birthDate).split("-");
          formatedDate = formatedDate[2] + "/" + formatedDate[1] + "/" + formatedDate[0];
          this.portabilityForm.patchValue({ inputNames: dataInfo["obj"].firstName });
          this.portabilityForm.patchValue({ inputLastNames: dataInfo["obj"].lastName });
          this.portabilityForm.patchValue({ inputBornDate: formatedDate });

          //textos para mostrar
          this.inputNamesText = dataInfo["obj"].firstName;
          this.inputLastNamesText = dataInfo["obj"].lastName;
          this.inputBornDateText = formatedDate;

          this.portabilityForm.get('inputCC').disable();

          //seleeciona como activa la pestaña 2
          this.activeTab = 2;
          //cambia a la pestaña 2
          this.changeTab(2);
          //habilita boton de regresar
          this.isBackDisabled = false;
          //muestra el icono check del paso 1
          this.isStep1Checked = true;
        }),
          (err) => {
            this.isLoading = false;
            this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
            this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
            this.isShowModal = true;
          });

      }),
        (err) => {
          this.isLoading = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });

    } else if (this.activeTab == 2) {
      // Validacion de campos paso 2
      if (this.portabilityForm.get('inputNumber').invalid
        || this.portabilityForm.get('inputOperator').invalid
        || this.portabilityForm.get('inputCodeValidation').invalid
        || this.portabilityForm.get('inputIMEI').invalid
        || this.portabilityForm.get('inputNames').invalid
        || this.portabilityForm.get('inputLastNames').invalid
        || this.portabilityForm.get('inputBornDate').invalid
        || this.portabilityForm.get('inputEmail').invalid
        || this.portabilityForm.get('inputCity').invalid
        || this.portabilityForm.get('inputAditionalNum').invalid
        || this.portabilityForm.get('inputFullAddress').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        this.pdfOpened = false;
        return;
      }

      
    if (!this.LANG.isValidPhoneZero(this.portabilityForm.get('inputAditionalNum').value)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      this.pdfOpened = false;
      return false;
    }
    
    if(!this.pdfOpened){
      //Si no ha visto el pdf al menos una vez
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('SIGNATURE_PDF_NOT_OPEN');
      this.isShowModal = true;
      return false;
    }

      //validacion de IMEI
      this.isLoading = true;
      this.portabilityService.validateIMEI(this.portabilityForm.get('inputIMEI').value).subscribe((data => {
        this.isLoading = false;
        if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || data['obj'].valid != true) {
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERROR_IMEI');
          this.isShowModal = true;
          return false;
        }

        let jsonData = {          
          "msisdn":this.portabilityForm.get('inputNumber').value,
          "pin":this.portabilityForm.get('inputCodeValidation').value          
        }
    
        let codificador = new CodificadorJWT();
        const jwt = codificador.generarJSON(jsonData, this.valueAes);
        const body = { args: jwt };

        //validacion del PIN enviado por SMS
        this.isLoading = true;
        this.portabilityService.validateSMSCodeAndDocument(JSON.stringify(body)).subscribe((data => {
            this.isLoading = false;
            if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
              this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
              this.modalContent = this.LANG.getLangText('LOGIN_LABEL_WRONG_PIN');
              this.isShowModal = true;
              return false;
            }

            //activa una nueva tab 3
            this.changeTab(3);
            //selecciona la pestaña 3 como actual
            this.activeTab = 3;
            //deja el codigo sms como valido
            this.isCodeSent = true;
            //activa el boton de regresar
            this.isBackDisabled = false;
            //muestra el icono de checkeado del paso 2
            this.isStep2Checked = true;
            //cambia el label del boton de continuar por finalizar
            this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');

          }),
            (err) => {
              this.isLoading = false;
              this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
              this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
              this.isShowModal = true;
            });

      }),
        (err) => {
          this.isLoading = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });



    } else if (this.activeTab == 3) {
      //realiza proceso de request de portabilidad
      this.endStep();
    }

  }

  /**
   * Description: Método que cambia la pantalla para volver con el paso 1 o 2 del proceso de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  backStep() {

    if (this.activeTab <= 2) {
      this.isBackDisabled = true;
    }

    if (this.activeTab > 1) {
      this.changeTab((this.activeTab - 1));
      this.activeTab = (this.activeTab - 1);
      this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
    }
  }

  /**
   * Description: Método que cambia de tab o paso en el wizard
   * Autor: Diego Diaz
   * @param tab paso que se desea mostrar
   * @return N/A
   */
  changeTab(tab) {

    this.scrollToForm();
    var aStep = document.getElementById('step' + tab + '-tab');
    (<any>aStep).href = "#step" + tab;
    aStep.click();
  }

  configTimer() {
    this.timeLeft = 59;
    this.showTimeLeft = '59';
    this.blockSendSMS = true;
    clearInterval(this.interval);
    this.startTimer();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
        if(this.timeLeft < 10) {
          this.showTimeLeft = '0'+String(this.timeLeft);
        }
        else {
          this.showTimeLeft = String(this.timeLeft);
        }
      } else {
        this.blockSendSMS = false;
      }
    },1000)
  }  

  /**
   * @description Metodo que hace scroll al inicio del formulario
   * @author eciro
   */
  scrollToForm() {
    $('html,body').animate({
      scrollTop: $("#link-steps-activation-menu").offset().top
    }, 'slow');
  }

  /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  sendValidationCode() {

    // Validacion de campos paso 1
    if (this.portabilityForm.get('inputNumber').invalid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_INVALID_PHONE_VALIDATION');
      this.isShowModal = true;
      return;
    }

    if (!this.LANG.isValidPhoneZero(this.portabilityForm.get('inputNumber').value)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      return false;
    }

    //procesar envio sms validacion
    this.isLoading = true;
    this.portabilityService.sendSMSCode(this.portabilityForm.get('inputNumber').value).subscribe((data => {
      this.isLoading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERORO_SEND_SMS');
        this.isShowModal = true;
        return false;
      }

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_SEND_CODE');
      this.isCodeSent = false;
      this.isShowModal = true;

      this.configTimer();
    }),
      (err) => {
        this.isLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
   * Description: Método que abre la ventana de carga de archivos adjuntos
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  loadHiddenFile(id: string) {
    $("#" + id).click();
  }

  /**
   * Description: Método que valida si se ha subido un archivo y lo marca como OK
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  setFileOkFlag($event) {
    let id = $event.target.id;
    let filename = $('#' + id).val();

    /**
     * @AddBy Julian Ciro
     * Se añade validación que verifica la extensión del archivo
     */
    const isFileValid = constants.EXTENSION_FILE_AVAILABLE.includes(filename.substring(filename.lastIndexOf('.')).toUpperCase());
    if (!isFileValid) {
      this.modalTitle = this.LANG.getLangText('EXTENSION_FILE_INVALID_TITTLE');
      this.modalContent = this.LANG.getLangText('EXTENSION_FILE_INVALID');
      this.isShowModal = true;
      $('#' + id).val(''); //ID del input file hiddden
      $('#' + id + 'Face').val(''); //ID del input que muestra la ruta del archivo seleccionado
      return;
    }

    $('#' + id + "Face").val(filename);
    //carga el archivo en base64
    this.getBase64($event.target, id);

    
    if (id == 'inputFileDocCopy') {
      this.isFileLoadDocCopy = true;
    }
    if (id == 'inputFileDocCopyFront') {
      this.isFileLoadDocCopyFront = true;
    }
    if (id == 'inputFileDocCopyReverse') {
      this.isFileLoadDocCopyReverse = true;
    }
  }

  /**
   * Description: Método que envia la solicitud de procesamiento de portabilidad al backend
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  endStep() {
    // Validacion de campos generales y de archivos
    if (this.portabilityForm.invalid || !this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    var fileList = [];
    
    if (this.fileLoadDocCopyData != null) {
      fileList.push({ "name": 'CI.'+$('#inputFileDocCopy').prop('files')[0].name.split('.').pop(), "attached": this.fileLoadDocCopyData.split(',')[1] });
    }
    if (this.fileLoadDocCopyFrontData != null) {
      fileList.push({ "name": 'CI_1.'+$('#inputFileDocCopyFront').prop('files')[0].name.split('.').pop(), "attached": this.fileLoadDocCopyFrontData.split(',')[1] });
    }
    if (this.fileLoadDocCopyReverseData != null) {
      fileList.push({ "name": 'CI_2.'+$('#inputFileDocCopyReverse').prop('files')[0].name.split('.').pop(), "attached": this.fileLoadDocCopyReverseData.split(',')[1] });
    }
    /*
    metodo que encripta la informacion sensible de los usuarios
    */
    let jsonData = {
      "identification": this.LANG.encrypt(this.portabilityForm.get('inputCC').value),
      "msisdn": this.LANG.encrypt(this.portabilityForm.get('inputNumber').value),
      "operator": this.LANG.encrypt(this.portabilityForm.get('inputOperator').value),
      "imei": this.LANG.encrypt(this.portabilityForm.get('inputIMEI').value),
      "icc": this.LANG.encrypt(this.portabilityForm.get('inputICC').value),
      "type": constants.TYPE_CED,
      "givenName": this.LANG.encrypt(this.portabilityForm.get('inputNames').value),
      "familyName": this.LANG.encrypt(this.portabilityForm.get('inputLastNames').value),
      "birthDate": this.portabilityForm.get('inputBornDate').value,
      "city": this.LANG.encrypt(this.portabilityForm.get('inputCity').value),
      "email": this.LANG.encrypt(this.portabilityForm.get('inputEmail').value),
      "msisdnNotification": this.LANG.encrypt(this.portabilityForm.get('inputAditionalNum').value),
      "address": this.LANG.encrypt(this.portabilityForm.get('inputFullAddress').value),
      "attached": fileList,
      "pin": this.portabilityForm.get('inputCodeValidation').value,
      "firm": this.base64Img,
      "annexedQuantity": fileList.length + 1,
      "isNewModalityPrepaid": this.portabilityForm.get('inputCurrentPlan').value,
      "isCurrentModalityPrepaid": this.portabilityForm.get('inputCurrentPlan').value,

    };
    this.isLoading = true;
    this.portabilityService.sendPortabilityRequest(jsonData).subscribe((data => {
      this.isLoading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERROR_SENDING_REQUEST');
        this.isShowModal = true;
        return false;
      }
      this.scrollToForm();
      this.isFinishedProcess = true;
    }),
      (err) => {
        this.isLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
   * Description: Método que valida que existan los archivos adjuntos
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  validateAttachedFiles() {
    var isValidFileLoad = false;
    var fileDocCopy = $("#inputFileDocCopy")[0].files;
    var fileDocCopyFront = $("#inputFileDocCopyFront")[0].files;
    var fileDocCopyReverse = $("#inputFileDocCopyReverse")[0].files;
    if ((fileDocCopy.length != 0 || (fileDocCopyFront.length != 0 && fileDocCopyReverse.length != 0))) {
      isValidFileLoad = true;
    }
    return isValidFileLoad;
  }

  /**
   * Description: Método que permite la descarga del formulario de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return Formulario de portabilidad para descarga
   */
  downloadFormFile() {

    //procesar descarga formato
    this.isDownloading = true;
    this.portabilityService.getDocumentFormat().subscribe((data => {
      this.isDownloading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return false;
      }

      var fileToDownload: any = data["obj"][0].file;
      if (this.LANG.detectIEEdge() > 0)  // If Internet Explorer
      {
        var blob = this.LANG.base64toBlob(fileToDownload, 'file/pdf');
        window.navigator.msSaveOrOpenBlob(blob, constants.PORTABILITY_DOWNLOAD_FILE_NAME);
      } else {
        var url = constants.BASE64_PDF_FILE + fileToDownload;
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = url;
        a.download = constants.PORTABILITY_DOWNLOAD_FILE_NAME;
        a.click();
        window.URL.revokeObjectURL(url);
      }

    }),
      (err) => {
        this.isDownloading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
  * Description: Método que carga el archivo seleccionado
  * Autor: Diego Diaz
  * @param inputValue campo tipo file
  * @param id identificador
  * @return N/A
  */
  getBase64(inputValue, id) {
    var file: File = inputValue.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var _self = this;
    reader.onload = function () {
      
      if (id == 'inputFileDocCopy') {
        _self.fileLoadDocCopyData = reader.result;
        $("#inputFileDocCopyFrontFace").val("");
        $("#inputFileDocCopyReverseFace").val("");
        _self.fileLoadDocCopyFrontData = null;
        _self.fileLoadDocCopyReverseData = null;
      }
      if (id == 'inputFileDocCopyFront') {
        _self.fileLoadDocCopyFrontData = reader.result;
        $("#inputFileDocCopyFace").val("");
        _self.fileLoadDocCopyData = null;
      }
      if (id == 'inputFileDocCopyReverse') {
        _self.fileLoadDocCopyReverseData = reader.result;
        $("#inputFileDocCopyFace").val("");
        _self.fileLoadDocCopyData = null;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  
  openPdfEvent([isPdfOpened, base64Img]){
    this.pdfOpened = isPdfOpened;
    if(base64Img){
      this.base64Img = base64Img;
    }
  }
  getSemillaAesParam(){
		this.privacyService.getGroupParameters("WS_SEMILLA").subscribe(((dataResponse:any) => {
      this.valueAes = dataResponse.obj[0].value
		}))
	}
}
